import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { formatISO } from "date-fns";
import { AltTransIncidentTasks } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { useMemo } from "react";

export function useAlternativeTransportIncidentTasks(
  incidentId: string | null | undefined,
  fromTime: Date | string,
  toTime: Date | string,
) {
  const params = useMemo(
    () => ({
      fromTime: formatISO(fromTime),
      toTime: formatISO(toTime),
    }),
    [fromTime, toTime],
  );

  const { data, status } = useQuery({
    queryKey: [
      "alternativeTransport",
      "incidentTasks",
      incidentId,
      fromTime,
      toTime,
    ],
    enabled: Boolean(incidentId),
    queryFn: async ({ signal }) => {
      const response = await axiosClient.get<AltTransIncidentTasks>(
        `${getBackendUrl()}/alternative-transport-planning/incident/${incidentId}/tasks`,
        {
          signal,
          params,
        },
      );
      return response.data;
    },
    refetchInterval: 60 * 1000, // Every minute
    retry: false,
  });

  return { data, status };
}
